import { PrintType, PrintTypesMap, SharingDraftConfiguration } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { getColorsFromPrintColorRGBs } from '@/model/draftMapper/utils/getPrintColors';
import { isSharingDraftConfigurationWithText } from '@/model/draftMapper/utils/isSharingDraftConfigurationType';
import { getClosestPrintColor } from '@/model/printType/getClosestPrintColor';
import { isDigital } from '@/model/printType/isDigital';
import { Embroidery, EmbroideryDigital } from '@/model/printType/printTypes';

export const getPrintType = (
  printTypes: PrintType[],
  allPrintTypes: PrintTypesMap,
  sharingDraftConfiguration: SharingDraftConfiguration
) => {
  const printTypeId = sharingDraftConfiguration.printTypeId;
  let printType = printTypes.find(({ id }) => id === printTypeId);

  if (
    printTypeId === EmbroideryDigital &&
    isSharingDraftConfigurationWithText(sharingDraftConfiguration)
  ) {
    // update text from embroidery (digital) to embroidery (vector)
    const embroideryVector = printTypes[Embroidery];
    if (embroideryVector) {
      // map digital colors to print colors of print type
      const printColorRGBs = sharingDraftConfiguration.printColorRGBs;
      if (printColorRGBs) {
        sharingDraftConfiguration.printColorId = getColorsFromPrintColorRGBs(printColorRGBs)
          .map(({ fill }) => getClosestPrintColor(embroideryVector, fill.toUpperCase()).id)
          .join(' ');
        delete sharingDraftConfiguration.printColorRGBs;
      }

      printType = embroideryVector;
    }
  }

  if (!printType) {
    const wantedPrintType = allPrintTypes.get(printTypeId);
    if (wantedPrintType && isDigital(wantedPrintType)) {
      // if the current digital print type is not available on the product type anymore
      //  try to use a different digital print type as fallback
      printType = printTypes.find(isDigital);
    }
  }

  return assertDefined(printType);
};
